const GluceraNavigationRoutes = {
  HOME: "/",
  HOMEPAGE: "/homepage",
  CREATE_ONBOARDING: "/create-onboarding",
  EDIT_ONBOARDING: (id: string) => `/edit-onboarding/${id}`,
  EDIT_ONBOARDING_ROUTE: "/edit-onboarding/:id",
  ONBOARDING_LIST: "/onboarding-list",
  ONBOARDING_WELCOME: "/onboarding-welcome",
  ONBOARDING_LOGINPAGE: "/onboardingLoginpage",
  GENDER_PAGE: "/genderpage",
  RACE_PAGE: "/racepage",
  AGE_PAGE: "/agepage",
  HEIGHT_WEIGHT_PAGE: "/heightweightpage",
  TYPE_OF_DIABETES: "/typeofdiabetes",
  CURRENT_MEDICATIONS: "/currentmedications",
  ADD_MEDICATIONS: "/addmedications",
  WORKOUT_PAGE: "/workoutpage",
  WEIGHT_LOSS: "/weightloss",
  TARGET_WEIGHT: "/targetweight",
  MAIN_REASON_WEIGHT_LOSS: "/mainreasonweightloss",
  DIETPAGE: "/dietpage",
  EATMEALPAGE: "/eatmealpage",
  MEAL_CAMERA: "/meal-camera",
  SCANNED_FOOD_DETAIL: "/scanned-food-detail",
  SCANNED_BARCODE_DETAIL: "/scanned-barcode-detail",
  EDIT_FOOD: "/edit-food",
  ADD_FOOD: "/add-food",
  FOOD_NUTRITION: "/food-nutrition",
  IntermittentFastingPage: "/intermittentfastingpage",
  eatingwindowpage: "/eatingwindowpage",
  ASSESSMENT_SUMMARY: "/assessment-summary",
  thankyoupage: "/thankyoupage",
  appdevicespage: "/appdevicespage",
  fitbitConnectionPage: "/fitbitconnectionpage",
  fitbitCallbackPage: "/fc",
  profilepage: "/profilepage",
  ActivityPage: "/ActivityPage",
  Mealpage: "/mealpage",
  mealdetailpage: "/mealdetailpage",
  mealindetailpage: "/mealindetailpage",
  ADDMEALPAGE: "/addmealpage",
  ADDMEDICATIONPAGE: "/addmedicationpage",
  connnettofitbitpage: "/connnettofitbitpage",
  FITNESS: "/fitness",
  TRENDS_PAGE: "/trends",
  EDIT_PROFILE: "/profile/edit",
  PROFILE_GOALS: "/profile/goals",
  PROFILE_DEVICES: "/profile/devices",
  NOTIFICATIONS: "/profile/notifications",
  PROFILE_PREFERENCES: "/profile/preferences",
  PROFILE_PRIVACY: "/profile/privacy",
  PROFILE_HELP: "/profile/help",
  PROFILE_ABOUT: "/profile/about",
  GETTING_STARTED: "/profile/getting-started",
  FAQS: "/profile/faqs",
  CONTACT_SUPPORT: "/profile/contact-support",
  TERMS_OF_SERVICE: "/profile/terms-of-service",
  PRIVACY_POLICY: "/profile/privacy-policy",
  LICENSES: "/profile/licenses",
  STEPS_DETAIL: "/fitness/steps",
  HEART_RATE_DETAIL: "/fitness/heart-rate",
  CALORIES_DETAIL: "/fitness/calories",
  ACTIVE_MINUTES_DETAIL: "/fitness/active-minutes",
  HEALTH_VITALS_ALL: "/fitness/health-vitals",
  SLEEP_DETAIL: "/fitness/sleep",
  SPO2_DETAIL: "/fitness/spo2",
  BREATHING_DETAIL: "/fitness/breathing",
  TEMPERATURE_DETAIL: "/fitness/temperature",
  STRESS_SCORE_DETAIL: "/fitness/stress-score",
  HRV_DETAIL: "/fitness/hrv",
  NUTRITION_SUMMARY: "/nutrition-summary",
  MEAL_HISTORY: "/meal-history",
  BITE_BALANCE: "/bite-balance",
  BBS_DETAIL: "/bbs-detail",
  FOUR_PILLARS_DETAIL: "/four-pillars-detail",
  BARCODE_PRODUCT_DETAIL: "/barcode-product-detail",
  PRAL_SCORE: "/pral-score-detail",
  MICRONUTRIENT_RISK: "/micronutrient-risk-detail",
  GUT_REST: "/gut-rest-detail",
  RECOVERY_HRV: "/recovery-hrv-detail",
  CARB_FIBER: "/carb-fiber-ratio-detail",
  FAT_QUALITY: "/fat-quality-detail",
  MICRO_DIVERSITY: "/micro-diversity-detail",
  FOOD_SCORE: "/food-score-detail",
  SUGAR_LOAD: "/sugar-load-detail",
  METABOLIC_STABILITY: "/metabolic-stability-detail",
  LIFESTYLE_SCORE: "/lifestyle-score-detail",
  MEDICATIONS: "/medication-management",
  SUGGESTED_WORKOUTS: "/suggested-workouts",
  EXERCISE_VIDEOS: "/exercise-videos",
  AI_INSIGHTS: "/ai-insights",
  GROUP_MEMBER_DETAIL: "/group-member-detail",
  GROUP_MEMBERS_LIST: "/group-members",
  INVITE_MEMBER: "/invite-member",
  GLUCOSE_READINGS: "/profile/glucose-readings",
  WEIGHT_MANAGEMENT_DETAIL: "/weight-management-detail",
  HEALTH_INSIGHTS: "/health-insights",
  /** Scaffold — rename when product name/path is finalized */
  CUSTOM_SCREEN: "/custom-screen",
};
export default GluceraNavigationRoutes;
